// extracted by mini-css-extract-plugin
export default {"innerWrapper":"name-indexer_innerWrapper__kcQD5","nameIndex":"name-indexer_nameIndex__GUT6R","valueIndex":"name-indexer_valueIndex__JFZYe"};